import { inject } from '@aesop-fables/containr';
import { DataCache, Predicate, injectDataCache, predicate } from '@aesop-fables/scrinium';
import { Observable, combineLatest, map } from 'rxjs';
import { Predicates } from './Types';
import { drillDownWizardKey, DrillDownWizard, AdminTierTypeEnum } from '../services/drillDown';
import { teamStorageKey, TeamCompartments } from '../data/team';
import { TeamData } from '../models/TeamData';

@predicate(Predicates.TeamSelected)
export class TeamRevenueAccessResolved implements Predicate {
  constructor(
    @inject(drillDownWizardKey)
    private readonly drillDownWizard: DrillDownWizard,
    @injectDataCache(teamStorageKey)
    private readonly teamDataCache: DataCache<TeamCompartments>,
  ) {}

  createObservable(): Observable<boolean> {
    return combineLatest([
      this.drillDownWizard.initialized$,
      this.drillDownWizard.highestRevenueAccess$,
      this.teamDataCache.observe$<TeamData>('team'),
    ]).pipe(
      map(
        ([initialized, highestRevenueAccess, team]) =>
          initialized &&
          typeof team !== 'undefined' &&
          (highestRevenueAccess === AdminTierTypeEnum.Group ||
            highestRevenueAccess === AdminTierTypeEnum.Team),
      ),
    );
  }
}
